import React from 'react';
import { Grid } from 'semantic-ui-react';

import { AccordionWrapper } from 'react-lib/dist/components-es';
import IExposureMonitoringContainer from './IExposureMonitoringContainer';
import IProvidedInformationContainer from './IProvidedInformationContainer';
import IPPMInformationContainer from './IPPMInformationContainer';
import IPPEInformationContainer from './IPPEInformationContainer';

type Props = {
  values: any;
  disabled: boolean;
  initialData: any;
  setFieldValue: (arg1: string, arg2: string) => void;
  errors: any;
};

const IPreventionProtectionMeasuresContainer = ({
  values,
  disabled,
  initialData,
  setFieldValue,
  errors,
}: Props) => {
  const getContainerContent = () => {
    return (
      <Grid stackable columns={2}>
        <Grid.Column className="detailsGridCol" width={16}>
          <IPPMInformationContainer
            values={values}
            disabled={disabled}
            setFieldValue={setFieldValue}
            errors={errors}
          />
          <IPPEInformationContainer
            initialData={initialData}
            setFieldValue={setFieldValue}
            values={values}
            disabled={disabled}
            errors={errors}
          />
          <IExposureMonitoringContainer
            values={values}
            disabled={disabled}
            errors={errors}
            setFieldValue={setFieldValue}
          />
          <IProvidedInformationContainer
            values={values}
            disabled={disabled}
            errors={errors}
            setFieldValue={setFieldValue}
          />
        </Grid.Column>
      </Grid>
    );
  };
  return (
    <AccordionWrapper
      accordionTitle="inventory.details.page.prevention.protection.measures.container.title"
      className="containerReducedWhiteSpace"
      render={getContainerContent}
    />
  );
};

export default IPreventionProtectionMeasuresContainer;
